import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeView from '../views/HomeView.vue'
import homePage from '../views/index/homePage.vue'
import payList from '../views/pay/payList.vue'
import payCode from '../views/pay/payCode.vue'
import agreementPage from '../views/agreement/agreementPage.vue'
import paymentPage from '../views/ability/paymentPage.vue'
import vicinityPage from '../views/ability/vicinityPage.vue'
import forgotPassword from '../views/pay/forgotPassword.vue'
import pharmacy from '../views/pharmacy/indexPage.vue'
import insurance from '../views/insurance/indexPage.vue'
import my from '../views/my/indexPage.vue'
import useAg from '../views/other/user_agee.vue'
import zxwzPage from '../views/zxwz/zxwzPage.vue'

import drugListPage from '../views/index/durg_list_page.vue'
import loginPage from '../views/login/loginPage.vue'
import fromWxPage from '../views/login/fromWx.vue'

import paymentCodePage from '../views/outer/paymentCodePage.vue'
import nearestDurgPage from '../views/outer/nearest_durg_page.vue'

import updateLoginPwdPage from '../views/my/update_login_pwd_page.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: { name: 'index' }
  },
  {
    path: '/index/homePage',
    name: 'index',
    component: homePage
  },
  {
    path: '/login/loginPage',
    name: 'login',
    component: loginPage
  },  
  {
    path: '/pay/payList',
    name: 'payList',
    component: payList
  },
  {
    path: '/pay/payCode',
    name: 'payCode',
    component: payCode
  },
  {
    path: '/pay/forgotPassword',
    name: 'forgotPassword',
    component: forgotPassword
  },
  {
    path: '/agreement/agreementPage',
    name: 'agreementPage',
    component: agreementPage
  },
  {
    path: '/ability/paymentPage',
    name: 'paymentPage',
    component: paymentPage
  },
  {
    path: '/zxwz/zxwzPage',
    name: 'zxwzPage',
    component: zxwzPage
  },  
  {
    path: '/ability/vicinityPage',
    name: 'vicinityPage',
    component: vicinityPage
  },
  {
    path: '/pharmacy/indexPage',
    name: 'pharmacy',
    component: pharmacy
  },
  {
    path: '/insurance/indexPage',
    name: 'insurance',
    component: insurance
  },
  {
    path: '/my/indexPage',
    name: 'my',
    component: my
  },
  {
    path: '/other/user_agee',
    name: 'useAg',
    component: useAg
  },
  {
    path: '/index/drugListPage',
    name: 'durgList',
    component: drugListPage
  }, 
  {
    path: '/login/fromWxPage',
    name: 'fromWx',
    component: fromWxPage
  },  
  
  {
    path: '/outer/abcPage',
    name: 'paymentCodePage',
    component: paymentCodePage
  },
  {
    path: '/outer/nearestDurgPage',
    name: 'nearestDurgPage',
    component: nearestDurgPage
  }, 
  {
    path: '/my/updateLoginPwdPage',
    name: 'updateLoginPwdPage',
    component: updateLoginPwdPage
  }, 
  
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/HomeView.vue')
  // }
]

const router = new VueRouter({
  routes
})

export default router
